import React from 'react';
import ReactDOM from 'react-dom';
import { Query } from '@apollo/client/react/components';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { mapAfter } from 'apollo-relay/update-query';

import Modal from 'four-nets/ui-v2/modal/modal';
import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import FetchMore from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';

import LikersList from 'four-nets/photoblog/posts/common/likers-list/likers-list';
import query, { CommentLikersLoaderQuery, CommentLikersLoaderQueryVariables } from '../comment-likers-loader.graphql';

export interface Props {
    id: string;
    open: boolean;
    onClose: () => any;
}

interface State {
    loading?: boolean;
    render?: boolean;
}

class CommentLikersDialog extends React.PureComponent<Props, State> {
    state = { loading: false };

    render() {
        const { open, onClose, id } = this.props;

        return (
            <Modal title={<FormattedMessage id='LIKE' />} open={open} onClose={onClose}>
                <Query<CommentLikersLoaderQuery, CommentLikersLoaderQueryVariables>
                    query={query}
                    variables={{ commentId: id }}
                    fetchPolicy='cache-first'
                >
                    {({ data, loading, fetchMore }) => {
                        return (
                            <LoadingWrapperView loading={loading}>
                                {data && data.comment && data.comment.likers ? <LikersList {...data.comment} /> : null}
                                {data &&
                                data.comment &&
                                data.comment.likers &&
                                data.comment.likers.pageInfo.hasNextPage ? (
                                    <FetchMore
                                        disabled={this.state.loading}
                                        loading={this.state.loading}
                                        onClick={() => {
                                            this.setState({ loading: true });
                                            const endCursor =
                                                data &&
                                                data.comment &&
                                                data.comment.likers &&
                                                data.comment.likers.pageInfo.endCursor;

                                            fetchMore({
                                                variables: { endCursor },
                                                updateQuery: (
                                                    previousResult = {} as CommentLikersLoaderQuery,
                                                    { fetchMoreResult = {} as CommentLikersLoaderQuery }
                                                ) => {
                                                    return {
                                                        ...previousResult,
                                                        ...fetchMoreResult,
                                                        post: {
                                                            ...(previousResult && previousResult.comment),
                                                            ...(fetchMoreResult && previousResult.comment),
                                                            likers: mapAfter(
                                                                previousResult.comment && previousResult.comment.likers,
                                                                fetchMoreResult.comment &&
                                                                    fetchMoreResult.comment.likers
                                                            ),
                                                        },
                                                    } as CommentLikersLoaderQuery;
                                                },
                                            }).then(() => {
                                                this.setState({ loading: false });
                                            });
                                        }}
                                    />
                                ) : null}
                            </LoadingWrapperView>
                        );
                    }}
                </Query>
            </Modal>
        );
    }
}

export default Styled({})(CommentLikersDialog);
